/* RepeatWeekComponent.js */

"use strict";
const Renderer = require("./RepeatWeekRenderer");
const BaseScheduleComponent = require("../../base/BaseScheduleComponent");

class RepeatWeekComponent extends BaseScheduleComponent {
    constructor(scheduleComp) {
        super(Renderer, scheduleComp);
    }
    static defaultValue() {
        let now = new Date();
        return {
            type: "dow",
            tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
            every: 1,
            dow: [2, 3, 4, 5, 6],
            time: {
                hour: 12,
                minute: 0,
            },
            start: {
                year: now.getFullYear(),
                month: now.getMonth(),
                date: now.getDate(),
            },
        };
    }
}
module.exports = RepeatWeekComponent;
